import React, { useState } from "react";

import HeaderMenuButton from "./header-menu-button";
import LanguageToggle from "./header-menu-language-switch";
import Logo from "../logo";
import { ROUTE } from "../../utils/constants";
import { useIsMobile } from "../../utils/isMobile";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import { useNavigation } from "../../utils/functions";

import "./styles.css";

function Header() {
  const { t } = useTranslation(); // 👉 ESSENCIAL

  const [open, setOpen] = useState(false);
  const hiddenHeader = false;
  const goTo = useNavigation();

  const menusItems = [
    { route: ROUTE.home, text: t("header.menu.home") },
    { route: ROUTE.about, text: t("header.menu.about") },
    { route: ROUTE.project, text: t("header.menu.portfolio") },
    { route: ROUTE.contact, text: t("header.menu.contact") },
  ];

  const isMobile = useIsMobile();

  function handleMobileNavigation(route) {
    setOpen(false);
    goTo(route);
  }

  function HeaderLanguageToggle() {
    return (
      <div className="header-language">
        <LanguageToggle></LanguageToggle>
      </div>
    );
  }

  function HeaderMobile() {
    return (
      <>
        <Logo />
        <div className="header-menu mobile">
          <MenuIcon className="footer-content-social-buttom" onClick={() => setOpen(!open)} />
        </div>
        {open && (
          <div className="header-menu-mobile-popup-container">
            <ul>
              {menusItems.map((item, index) => (
                <li key={index} onClick={() => handleMobileNavigation(item.route)}>
                  {item.text}
                </li>
              ))}
              <li>{HeaderLanguageToggle()}</li>
            </ul>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="header-container">
      {!isMobile ? (
        !hiddenHeader ? (
          <>
            <Logo />
            <div className="header-menu">
              {menusItems.map((item, index) => (
                <HeaderMenuButton key={index} path={item.route} text={item.text} />
              ))}
            </div>
            {HeaderLanguageToggle()}
          </>
        ) : (
          <Logo />
        )
      ) : (
        <HeaderMobile />
      )}
    </div>
  );
}

export default Header;
